// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"08937ca4","404":"da831183"}[chunkId] + ".chunk.js";
};